export default "__VITE_ASSET__DEtdlrcR__"